module.exports = __webpack_public_path__ + "static/blue-spaceship@2x-1435db1c40722d4f0b71867082fb8dc3.svg";